import { Col, Row, Typography } from "@visa/vds";
import Select from 'react-select';
import MCSGridRevert from "components/MCSGridRevert";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import { useAuthContextUser } from "context/AuthContext";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import ErrorPage from "pages/Error/ErrorPage";
import React, { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { DASHBOARD_CAROUSEL_IMAGES } from "_constants/DashboardConstants";
import "./DashboardPage.css"
import Carousel from '../../components/dashboard/Carousel'
import ProductCertificationCard from "./Components/ProductCertification/ProductCertificationCard";
import ImplementationTestingCard from "./Components/ImplementationTesting/ImplementationTestingCard";
import { DashboardStaffApi } from "services/dashboard.service";
import MCSSpace from "components/MCSSpace";
import MCSToolTip from "components/MCSToolTip";

const TRANSITION_TIME_IN_SECONDS = 12;

const DashboardPage = (_) => {
    const user = useAuthContextUser();
    const isExternalUser = user && user.isExternalUser;

    const { promiseInProgress } = usePromiseTracker();
    const [selectedBid, setSelectedBid] = useState(isExternalUser ? user.organization.bid : null);
    const [bids, setBids] = useState(null);
    const [error, setPageError] = useState(null);
    const fetchBids = async () => {
        trackPromise(DashboardStaffApi.getBids()
            .then(result => {
                let x = result.data.result.map((val) => {
                    return {
                        label: `${val.bid}: ${val.organizationName}`,
                        value: `${val.bid}: ${val.organizationName}`,
                        bid: val.bid
                    }
                })
                setBids(x);
            }))
    }

    useEffect(() => {
        if (bids === null && !isExternalUser) {
            fetchBids()
        }
    }, []);
    if (error) {
        return <ErrorPage text={error.message} />;
    }

    return (
        <GlobalAlertContext.Consumer>
            {(alertObj) => (
                <>
                    {promiseInProgress && <MCSOverlayLoading />}
                    <Row className="padding-right-10px padding-left-10px padding-top-20px background-color-gray full-viewport">
                        <MCSGridRevert>
                            <Row className="background-color-white margin-bottom-30px card-dashboard card-shadow ">
                                <Row>
                                    <Col className="vss-header"
                                        xs={4} sm={8} md={4} lg={5} xl={5}>
                                        <Typography className="dashboard-header-text" tag="h1" variant="headline">My Visa Secure Services</Typography>
                                        {user &&
                                            <Typography className="dashboard-subheader-text">Hi {user.firstName}, Welcome to your Visa Secure Dashboard.</Typography>
                                        }
                                    </Col>
                                    <Col className="vss-ilustration-image-panel vss-ilustration-dashboard-headline" xs={4} sm={8} md={4} lg={7} xl={7}>
                                        <Carousel slides={DASHBOARD_CAROUSEL_IMAGES} transitionTime={TRANSITION_TIME_IN_SECONDS} clickableImages={true} />
                                    </Col>
                                </Row>
                            </Row>
                            {!isExternalUser &&
                                <Row className="margin-bottom-30px">
                                    <Col className="padding-left-0px padding-right-0px">
                                        <label className="font-weight-bold padding-left-0px color-navy margin-right--2px">Search by 'BID' or 'Company Name'</label>
                                        <MCSToolTip
                                            message="A Visa Staff user can see a client's dashboard by searching BID or Company Name below. The Visa Staff will be able to view what a client user would see, with the exception that some buttons and available actions are slightly different."
                                            iconName="info"
                                        />
                                        <Select
                                            className="dashboard-select"
                                            label="Select Organization BID"
                                            onChange={(e) => setSelectedBid(e.bid)}
                                            options={bids}
                                            styles={{
                                                control: (provided, _) => ({
                                                    ...provided,
                                                    boxShadow: "none",
                                                    borderColor: "white"
                                                }),
                                            }}
                                        >
                                        </Select>

                                    </Col>
                                </Row>
                            }

                            {(isExternalUser || (!isExternalUser && selectedBid !== null)) ?
                                <>
                                    <Row className="background-color-gray">
                                        <ProductCertificationCard
                                            selectedBid={selectedBid}
                                            setPageError={setPageError}
                                        />
                                        <ImplementationTestingCard
                                            selectedBid={selectedBid}
                                            setPageError={setPageError}
                                        />
                                    </Row>
                                </>
                                : <MCSSpace height="100px" />
                            }
                        </MCSGridRevert>
                    </Row>
                </>
            )
            }
        </GlobalAlertContext.Consumer >
    );
}

export default DashboardPage;